export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const GET_FROM_CART = "GET_FROM_CART";
export const EDIT_CART_DETAILS = "EDIT_CART_DETAILS";

export const ADD_USER = "ADD_USER";
export const DELETE_USER = "DELETE_USER";
export const EDIT_USER = "EDIT_USER";
export const GET_USERS = "GET_USERS";
export const GET_SINGLE_USER = "GET_SINGLE_USER";
